import { Button, InlineBanner, Text } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React, { useState } from 'react'
import { useAppSelector } from '../../../state/hooks'
import {
  selectIsSavedService,
  selectCurrentSale,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { ServiceModal } from '../../react/modals/service-modal/ServiceModal'
import { STEPS } from '../../react/modals/service-modal/Steps/types'
import { getServiceAgendaBannerText } from '../../../functions/sale'

interface Props {
  shouldShowServiceBanner: boolean
}

export const SaleServiceBanner: React.FC<Props> = ({
  shouldShowServiceBanner,
}) => {
  const t = useT()
  const [showModal, setShowModal] = useState(false)

  const openServiceModal = () => {
    setShowModal(true)
  }

  const isSavedService = useAppSelector(selectIsSavedService)
  const currentSale = useAppSelector(selectCurrentSale)

  // Get service banner text with translation support
  const getServiceBannerText = () => {
    return getServiceAgendaBannerText(currentSale, t)
  }

  return (
    <>
      {showModal && (
        <ServiceModal
          close={() => setShowModal(false)}
          isEditing={true}
          startWithStep={STEPS.CUSTOMER_ITEM}
        />
      )}
      {shouldShowServiceBanner && (
        <InlineBanner variant="info" icon="info-circle">
          <Text type="label">
            {getServiceBannerText()}
            &nbsp;
            {!isSavedService && (
              <Button
                link
                className="vd-link vd-link--secondary"
                onClick={openServiceModal}
                data-testid="sale-service-banner-button"
                data-track="edit-service-agenda"
              >
                {t('Edit service', { _context: 'Service agenda edit button' })}
              </Button>
            )}
          </Text>
        </InlineBanner>
      )}
    </>
  )
}
